<template>
    <div class="current-seal">
        <p class="mt10">当前印章</p>
        <div class="empty-data" v-if="!sealImage">
            <div class="middle-center">
                <i class="iconfont iconukey ukey-font"></i>
                <p v-if="existUkey">
                    <span v-if="hasSeal">已插入UKEY，检测中...</span>
                     <span v-else-if="!hasRegisterNo">您的数字证书内没有统一社会信用代码信息，请尽快至就近的数字证书服务网点进行数字证书信息的更新</span>
                    <span v-else>已插入UKEY，但未检测到印章</span>
                </p>
                <p v-else>系统未检测到UKEY设备，请检查是否已插入UKEY设备</p>
            </div>
        </div>
        <div
            v-if="sealImage"
             class="seal-container">
            <div class="seal-content">
                <div class="seal-image transform-center">
                    <img :src="sealImage"
                         alt="">
                </div>
                <div class="seal-info">
                    <h4 class="title">{{certDetail.sealName}}</h4>
                    <div class="small-font info-content">
                        <p>
                            <span class="label tip">持有者：</span>
                            <span class="content-text">{{certDetail.user}}</span>
                        </p>
                        <p>
                            <span class="label tip">统一社会信用代码：</span>
                            <span class="content-text">{{certDetail.creditcode}}</span>
                        </p>
                        <p>
                            <span class="label tip">有效期起始时间：</span>
                            <span class="content-text">{{certDetail.createTime}}</span>
                        </p>
                        <p>
                            <span class="label tip">有效期结束时间：</span>
                            <span class="content-text">{{certDetail.expireTime}}</span>
                        </p>
                    </div>
                    <el-button type="primary"
                               @click="doValidateSeal"
                               size="medium">验 证</el-button>
                </div>
                <div class="seal-status">
                    <!-- <span class="tags info">有效</span> -->
                    <svg class="icon"
                         v-if="!app.isOld"
                         style="font-size:70px;"
                         aria-hidden="true">
                        <use :xlink:href="certDetail.status | statusFont"></use>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CurrentSeal',
    data () {
        return {
            sealImage: '',
            existUkey: false,
            hasSeal: true,
            certDetail: {
                user: '',
                creditcode: '',
                sealName: '',
                createTime: '',
                expireTime: '',
                status: 1,
                verify: false
            },
            loading: false,
            hasRegisterNo:true
        };
    },
    props: {
        hideNavigate: Boolean
    },
    inject: ['app'],
    computed: {
        quser () {
            return this.$store.getters.quser;
        }
    },
    mounted () {
        this.loading = true;
        setTimeout(() => {
            this.loading = false;
        }, 4000);
    },
    watch: {
        'app.cert': {
            handler (nv) {
                if (nv) {
                    this.existUkey = true;
                    this.getSealInfo();
                } else {
                    this.existUkey = false;
                }
            },
            immediate: true
        },
        'app.picData': {
            handler (nv) {
                if (nv) {
                    this.existUkey = true;
                    this.getSealInfo();
                }
            },
            immediate: true
        },
    },
    methods: {
        /**
         * 获取印章信息
         */
        async getSealInfo () {
            try {
                let issure;
                let requsetData = new FormData();
                requsetData.append('sealData', this.app.sealData);
                requsetData.append('picData', this.app.picData);
                requsetData.append('cert', this.app.cert);
                issure = await this.axios({
                    url: '/seal/verify',
                    method: 'POST',
                    data: requsetData
                });
                issure = issure.data;
                if (issure.code === 0) {
                    if (issure.result.pic_data) {
                        this.hasSeal = true;
                        this.sealImage = `data:image/png;base64,${issure.result.pic_data}`;
                        this.certDetail.user = this.app.ukey.getCertDetailSync(decodeURIComponent(this.app.cert), 17);
                        this.certDetail.creditcode = issure.result.creditcode;
                        this.certDetail.sealName = issure.result.seal_name;
                        this.certDetail.createTime = issure.result.not_before;
                        this.certDetail.expireTime = issure.result.not_after;
                        this.certDetail.status = issure.result.seal_status;
                    } else {
                        this.hasSeal = false;
                    }
                }
                else if (issure.code === 1200005) {
                    this.hasRegisterNo = false;
                }
                else {
                    this.hasSeal = false;
                }
            } catch (error) {
                this.hasSeal = false;
                console.log(error);
            }
        },


        /**
         * 验证
         */
        async doValidateSeal () {
            let resp, loading;
            try {
                loading = this.$loading();
                resp = await this.app.ukey.verifyCertificate(decodeURIComponent(this.app.cert));
                this.$message.success(resp.message);
            } catch (error) {
                this.$message.warning(error.message || error);
                console.log(JSON.stringify(error));
            } finally {
                loading && loading.close();
            }
        },
    }
};
</script>

<style lang="less" scoped>
.mt10 {
    margin-bottom: 10px;
}
.current-seal {
    .empty-data {
        position: relative;
        text-align: center;
        height: 400px;
        .ukey-font {
            font-size: 50px;
            color: @theme-color;
        }
    }

    .curr-seal-box {
        padding: 15px 30px 30px;
        .seal-container {
            min-height: 300px;
        }
    }
    .header {
        margin-bottom: 10px;
    }

    .seal-content {
        display: flex;
        justify-content: center;
        padding: 30px;
        border: 1px solid @border-color-base;

        .seal-image,
        .seal-image img {
            width: 120px;
            height: auto;
        }

        .seal-info {
            padding: 0 30px;
            flex: 1;

            .info-content {
                margin: 10px 0;
                .label {
                    display: inline-block;
                    width: 120px;
                }
            }
        }
    }
    // .etl-seal-container {
    //     min-height: 300px;
    //     .etl-seal-item {
    //         width: 300px;
    //         display: inline-block;
    //         margin-left: 30px;
    //         margin-top: 30px;
    //         border: 1px solid #efefef;
    //         vertical-align: top;
    //         .seal-image {
    //             height: 240px;
    //             padding: 20px;
    //             .img-wrapper {
    //                 width: 100%;
    //                 display: flex;
    //                 padding: 30px;
    //                 justify-content: center;
    //                 align-items: center;
    //             }
    //         }
    //         .title {
    //             line-height: 22px;
    //             text-align: center;
    //         }
    //     }
    // }
}
</style>


